import React, { useState, useRef, useEffect } from 'react';
import type { Editor } from '@tiptap/core';

interface TableMenuProps {
  editor: Editor;
}

export const TableMenu: React.FC<TableMenuProps> = ({ editor }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const insertTable = () => {
    editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run();
    setIsOpen(false);
  };

  const isInTable = editor.isActive('table');

  const runCommand = (command: () => void) => {
    command();
    setIsOpen(false);
  };

  return (
    <div className="table-menu-wrapper" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={isInTable ? 'is-active' : ''}
        title="Table"
      >
        Table
      </button>
      {isOpen && (
        <div className="table-menu-dropdown">
          {!isInTable ? (
            <button type="button" onClick={insertTable}>
              Insert Table (3x3)
            </button>
          ) : (
            <>
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().addColumnBefore().run())}>
                Add Column Before
              </button>
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().addColumnAfter().run())}>
                Add Column After
              </button>
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().deleteColumn().run())}>
                Delete Column
              </button>
              <hr />
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().addRowBefore().run())}>
                Add Row Before
              </button>
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().addRowAfter().run())}>
                Add Row After
              </button>
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().deleteRow().run())}>
                Delete Row
              </button>
              <hr />
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().toggleHeaderRow().run())}>
                Toggle Header Row
              </button>
              <button type="button" onClick={() => runCommand(() => editor.chain().focus().mergeOrSplit().run())}>
                Merge/Split Cells
              </button>
              <hr />
              <button type="button" className="danger" onClick={() => runCommand(() => editor.chain().focus().deleteTable().run())}>
                Delete Table
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TableMenu;
